let loadedTitlesPages = [];

document.addEventListener('DOMContentLoaded', function(){ 
	sampleSidebar();
	sampleFull();
	sampleAjax();
});


// toggle sidebar modal for titles samples
function sampleSidebar(){
	let btns = document.querySelectorAll('.sml-toggle');
	if (!btns) return;
	btns.forEach((btn) => {
		btn.addEventListener('click',function(event){
			event.preventDefault();
			document.body.classList.toggle('sample-sidebar-opened');

			let audio = document.querySelector('.modal-sample .audio audio');
			if (!audio) return;
			audio.pause();
		})
	})
}

// toggle full page modal for samples 
function sampleFull(){
	let btns = document.querySelectorAll('.msf-toggle');
	if (!btns) return;
	btns.forEach((btn) => {
		btn.addEventListener('click',function(event){
			event.preventDefault();
			document.body.classList.toggle('sample-full-opened');
			document.querySelector('.modal-sample-full').classList.remove('show-more');

			let audio = document.querySelectorAll('.modal-sample-full .audio audio');

			if (!audio) return;
			audio = audio[1];

			audio.pause();
		})
	})
}

// pull sample info for both modals 
function sampleAjax(){
	let btns = document.querySelectorAll('.block-samples .more, .block-samples .more-full, .block-titles .more, .block-titles .more-img');

	if (!btns) return;
	document.body.addEventListener('click', event => {

		if (!event.target.classList.contains('more')) return;
		let
			postId = event.target.dataset.postId,
			type = event.target.dataset.type,
			type_s = (type === 'full') ? '-full' : '',
			block = document.querySelector('.modal-sample'+type_s);
		if (block.dataset.loadedId === postId) {
			document.body.classList.add('sample-'+type+'-opened');
			let autoplay = event.target.getAttribute('data-autoplay');
			sampleSidebarPlayback(type, autoplay);
			return;
		}
		
		
		let data = {
			'action': 'sample_modal',
			'post_id': postId,
			'type' : type
		};
		param = new URLSearchParams(data).toString();
		fetch( snk_ajax_params.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: param
		} )
			.then( res => res.text() )
			.then( data => {
				block.dataset.loadedId = postId;
				block.querySelector('.inner').innerHTML = data;
				document.body.classList.add('sample-'+type+'-opened');
				let autoplay = event.target.getAttribute('data-autoplay');
				sampleSidebarPlayback(type, autoplay);
				if (type == 'full') {

					document.querySelector('.modal-sample-full .more').addEventListener('click',function(){
						document.querySelector('.modal-sample-full').classList.toggle('show-more');
					});
				}
			});
	});

	// btns.forEach((btn, index) => {
	//
	// 	btn.addEventListener('click',function(event){
	//
	// 		let
	// 		postId = btn.dataset.postId,
	// 		type = btn.dataset.type,
	// 		type_s = (type === 'full') ? '-full' : '',
	// 		block = document.querySelector('.modal-sample'+type_s);
	// 		console.log('block', block);
	// 		if (block.dataset.loadedId === postId) {
	// 			document.body.classList.add('sample-'+type+'-opened');
	// 			return;
	// 		}
	//
	// 		let data = {
	// 			'action': 'sample_modal',
	// 			'post_id': postId,
	// 			'type' : type
	// 		};
	// 		param = new URLSearchParams(data).toString();
	// 		fetch( snk_ajax_params.ajaxurl, {
	// 			method: 'POST',
	// 			headers: {
	// 				'Content-Type': 'application/x-www-form-urlencoded'
	// 			},
	// 			body: param
	// 		} )
	// 		.then( res => res.text() )
	// 		.then( data => {
	// 			block.dataset.loadedId = postId;
	// 			block.querySelector('.inner').innerHTML = data;
	// 			document.body.classList.add('sample-'+type+'-opened');
	// 			console.log('index', index);
	// 			sampleSidebarPlayback(type);
	//
	// 			if (type == 'full') {
	//
	// 				document.querySelector('.modal-sample-full .more').addEventListener('click',function(){
	// 					document.querySelector('.modal-sample-full').classList.toggle('show-more');
	// 				});
	// 			}
	// 		});
	// 	})
	// })
}


// run audio on actions
function sampleSidebarPlayback(type, autoplay){
	// console.log('123');
	let sepClass = '', blockClass = '.modal-sample';

	if (type === 'full') {
		sepClass = (window.innerWidth >= 768) ? '.col-r' : '.col-l';
		blockClass = '.modal-sample-full';
	}
	let block = document.querySelector(blockClass+'.audio-sample '+sepClass+' .audio');
	if (!block) return;

	

	let player = block.querySelector('audio'),
	isPlaying = false,
	old_player = document.querySelector('.block-samples audio');
	console.log(autoplay);
	if (autoplay == 'true') {
		old_player.pause();
		player.currentTime = 0;
		player.play();
	}
	// var simulateClick = function (elem) {
	// 	// Create our event (with options)
	// 	var evt = new MouseEvent('click', {
	// 		bubbles: true,
	// 		cancelable: true,
	// 		view: window
	// 	});
	//
	// 	console.log('elem', elem);
	// 	// If cancelled, don't dispatch our event
	// 	elem.dispatchEvent(evt);
	// };

	// if(window.innerWidth >= 1440) {
	//
	//
	// 	let second_audio_btn = document.querySelector('.modal-sample-full .col-l .play-btn');
	// 	if(second_audio_btn) {
	// 		console.log('2', second_audio_btn);
	// 		//simulateClick(second_audio_btn);
	// 		isPlaying ? player.pause() : player.play();
	// 	}
	//
	// }
	// else {
	// 	let first_audio_btn = document.querySelector('.modal-sample-full .col-r .play-btn');
	//
	// 	if ( first_audio_btn ) {
	// 		console.log('1', first_audio_btn);
	// 		//simulateClick(first_audio_btn);
	//
	// 		isPlaying ? player.pause() : player.play();
	// 	}
	//
	// }
	//
	// document.body.addEventListener('click', event => {
	//
	// 	if ( !event.target.classList.contains('js-play-btn') ) return;
	// 	isPlaying ? player.pause() : player.play();
	// });


	block.querySelector('.play-btn').addEventListener('click',function(event){
		event.preventDefault();
		var sounds = document.getElementsByTagName('audio');
		for(i=0; i<sounds.length; i++) sounds[i].pause();
		isPlaying ? player.pause() : player.play();
	});

	stopwatch(block.querySelector('.timer'));

	player.onplay = function() {
		isPlaying = true;
		block.dataset.status = 'pause';
		stopwatch.start();
	};

	player.onpause = function() {
		isPlaying = false;
		block.dataset.status = 'play';
		stopwatch.pause();
	};

	player.onended = function() {
		stopwatch.reset();
	};

	
}

// timer for audio
function stopwatch(timer) {
	var startTime;
	var elapsedTime = 0;
	var timerInterval;

	function timeToString(time) {
		let diffInHrs = time / 3600000;
		let hh = Math.floor(diffInHrs);

		let diffInMin = (diffInHrs - hh) * 60;
		let mm = Math.floor(diffInMin);

		let diffInSec = (diffInMin - mm) * 60;
		let ss = Math.floor(diffInSec);

		let formattedMM = mm.toString().padStart(1, "0");
		let formattedSS = ss.toString().padStart(2, "0");

		return `${formattedMM}:${formattedSS}`;
	}

	function print(txt) {
		timer.innerHTML = txt;
	}

	function start() {
		startTime = Date.now() - elapsedTime;
		timerInterval = setInterval(function printTime() {
			elapsedTime = Date.now() - startTime;
			print(timeToString(elapsedTime),timer);
		}, 10);
	}

	function pause() {
		clearInterval(timerInterval);
	}

	function reset() {
		elapsedTime = 0;
	}

	stopwatch.start = start;
	stopwatch.pause = pause;
	stopwatch.reset = reset;
}

// load and calculate initial titles
window.ajaxInitTitles = function initTitles(wWidth){
	let dataCount = 12;
	if (wWidth < 1800) dataCount = 6;
	if (wWidth < 767) dataCount = 4;
	document.querySelector('.block-titles').dataset.count = dataCount;
	ajaxTitles(1);

	loadedTitlesPages = [];

	showSlides = Math.ceil(snk_ajax_params.total_titles / dataCount);
	if (document.querySelector('#title-last')) {
		document.querySelector('#title-last').id = '';
	}
	document.querySelectorAll('[data-anchor="our-titles"] .fp-slidesNav li')[showSlides-1].id = 'title-last';
}

// pull next pages for titles slides
window.ajaxTitles = function loadTitlesSlide(page) {
	if (!loadedTitlesPages.includes(page)){
		loadedTitlesPages.push(page);

		let data = {
			'action': 'load_titles',
			'page': page,
			'count': document.querySelector('.block-titles').dataset.count,
		};
		param = new URLSearchParams(data).toString();
		fetch( snk_ajax_params.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: param
		} ) 
		.then( res => res.text() )
		.then( data => {
			document.querySelectorAll('.block-titles .fp-slide')[page - 1].querySelector('.wrap').innerHTML = data;
			// sampleAjax();
			setTimeout(function(){
				fullpage_api.reBuild(); 
			}, 500);
		});
	} 
}